<template>
  <div class="paySettings">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="dictPay"><p>第三方支付</p><span :class="paySwitch?'checked':''" @click="checkDictPay" /></div>
      <div class="bankPay">
        <div class="titPay">
          <span>常用支付</span>
        </div>
        <div class="payList">
          <ul>
            <li v-for="(bank,index) in depoistBankList">
              <div class="item"><img :src="require('@/assets/images/bank/bank_icon/'+logoList[index]+'.png')"><span>{{ bank.bankName }}</span></div>
              <img src="@/assets/images/template/toolbar_delete.png" @click="deleteBank(bank.id)">
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--设置第三方支付失败-->
    <div v-if="isDictPayPop" class="popFixed">
      <div class="masking" @click="closePop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>{{ isErrMessage }}</p>
        </div>
        <div class="btnCon only">
          <span @click="closePop">知道了</span>
        </div>
      </div>
    </div>
    <!--删除成功-->
    <div v-if="isDeletePop" class="popFixed">
      <div class="masking" @click="closeDeletePop" />
      <div class="tcCon">
        <div class="item">
          <p>删除成功</p>
        </div>
        <div class="btnCon only">
          <span @click="closeDeletePop">确认</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/paySettings.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'
export default {
  name: 'PaySettings',
  components: { Header, Chat },
  data() {
    return {
      title: '支付设置',
      isHasBank: false,
      rightContent: 'isNo',
      depoistBankList: '',
      bankLogoList: process.env.VUE_APP_BANKLOGO,
      logoList: [],
      isDictPayPop: false,
      isErrMessage: '',
      isDeletePop: false,
      paySwitch: false
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.depositBankList()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    closePop() {
      this.isDictPayPop = !this.isDictPayPop
    },
    closeDeletePop() {
      this.isDeletePop = !this.isDeletePop
    },
    checkDictPay() {
      this.paySwitch = !this.paySwitch
      this.initPaySwitch(this.paySwitch)
    },
    initPaySwitch(paySwitch) {
      const readyData = { payswitch: paySwitch }
      api.updatePaySwitch(this.$qs.stringify(readyData)).then(res => {
        if (res.status) {
          if (res.data.code != 200) {
            this.toggleFixed()
            this.isErrMessage = res.data.data
            this.isDictPayPop = true
          }
        }
      })
    },
    depositBankList() {
      api.getDepositBankList().then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data.depoistBankList) {
              this.depoistBankList = res.data.data.depoistBankList
              this.paySwitch = res.data.data.payswitch
              for (const i in this.depoistBankList) {
                if (this.bankLogoList.indexOf(this.depoistBankList[i].bank) >= 0) {
                  this.logoList.push(this.depoistBankList[i].bank)
                } else {
                  this.logoList.push('bank')
                }
              }
            }
          }
        }
      })
    },
    deleteBank(id) {
      let readyData = { id: id }
      readyData = this.$qs.stringify(readyData)
      this.$bus.$emit('loading', false)
      api.deleteDepositBank(readyData).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.depositBankList()
          }
        }
      })
    }
  }
}
</script>
